/**
 * Load active tabs once
 */
export const tabsMixin = {
  data: () => ({
    tabs: {
      active: 0,
      loaded: [0]
    }
  }),
  methods: {
    isTabActive(tab) {
      return this.tabs.active === tab;
    },
    isTabLoaded(tab) {
      return this.tabs.loaded.includes(tab);
    },
    loadTab(tab) {
      if (!this.isTabLoaded(tab)) {
        this.tabs.loaded.push(tab);
      }
    },
    loadTabById(tab) {
      let tabId = tab;
      if (this.$refs.tabs && this.$refs.tabs.$children && this.$refs.tabs.$children[tab]) {
        tabId = this.$refs.tabs.$children[tab].$attrs.id || tab;
      }
      this.loadTab(tabId);
    },
    resetLoadedTabs() {
      this.tabs.loaded = [0];
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/tabsMixin.js